import React from "react";
import { t } from "@lingui/macro";
import { i18n } from "idc-ui-react";
// Fluent UI
import { Persona, PersonaSize, Text } from "@fluentui/react";

// The sizes that are allowed in the Persona component from Fabric
const personaSizes = [10, 16, 24, 28, 32, 40, 48, 72, 100];

const warnOnInvalidSize = size => {
  console.warn(
    `Invalid size value: ${size}. Valid values are: ${JSON.stringify(
      personaSizes
    )}. The size will default to 48.`
  );
};

export default ({
  name,
  username,
  position,
  imageUrl,
  className = "",
  size = 48
}) => {
  const sizeIsValid = personaSizes.includes(size);
  if (!sizeIsValid) {
    warnOnInvalidSize(size);
  }

  let badgeSize = sizeIsValid ? `size${size}` : `size${48}`;
  return (
    <Persona
      className={className}
      size={PersonaSize[badgeSize]}
      text={name ? name : username}
      tertiaryText={<Text> {i18n._(t`Username: ${username}`)} </Text>}
      secondaryText={
        position
          ? i18n._(t`${position.name} in ${position.orgUnit.name}`)
          : null
      }
      imageUrl={imageUrl}
      imageInitials={name && name.initials}
      initialsColor="darkBlue"
    />
  );
};
